import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Field,
  FieldArray,
  getFormValues,
  isValid,
  reduxForm,
  change,
  destroy,
} from 'redux-form';
import SwitchField from 'components/Fields/ReduxForm/SwitchField';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import SearchItemOrCategory from 'components/Fields/ReduxForm/SearchItemOrCategory';
import OptionVariantField from 'components/Fields/ReduxForm/OptionVariantField';
import ItemRelationField from 'components/Fields/ReduxForm/ItemRelationField';
import {
  onChangeItemRewardBuyXGetY,
  onChangeSwitchField,
  setAccordionActiveKey,
} from 'actions/businessLibrary/promo/promo';
import ReadOnlyItemVariant from 'components/Fields/ReduxForm/ReadOnlyItemVariant';
import styles from './BuyXGetY.css';

const validate = values => {
  const errors = {};
  const itemsErrors = [];
  if (!values.rewardType) {
    errors.rewardType = 'This field is required';
  } else if (values.rewardType === 'freeItem') {
    if (values.items) {
      values.items.forEach((member, index) => {
        const memberErrors = {};
        if (!member.quantity) {
          memberErrors.quantity = 'Quantity is required';
          itemsErrors[index] = memberErrors;
        } else if (member.quantity < 1) {
          memberErrors.quantity = 'The quantity must be greater than 0';
          itemsErrors[index] = memberErrors;
        } else if (member.quantity > 99) {
          memberErrors.quantity = 'The quantity must be less than 99';
          itemsErrors[index] = memberErrors;
        }
        if (!member.name) {
          memberErrors.name = 'The item is required';
          itemsErrors[index] = memberErrors;
        }
      });
    }
  } else if (values.rewardType === 'discount') {
    if (!values.discountAmount) {
      errors.discountAmount = 'Amount is required';
    }
    // discountType is true = percentage, '' = Rp
    if (values.discountType === true) {
      if (parseFloat(values.discountAmount) > 100) {
        errors.discountAmount = 'Amount must be less than or equal to 100%';
      } else if (parseFloat(values.discountAmount) <= 0) {
        errors.discountAmount = 'Amount must be greater than 0%';
      }
    } else if (parseInt(values.discountAmount) < 1) {
      errors.discountAmount = 'Amount must be greater than 0';
    } else if (parseInt(values.discountAmount) > 100000000000) {
      errors.discountAmount = 'Amount must be less than 100.000.000.000';
    }
  }
  if (itemsErrors.length) {
    errors.items = itemsErrors;
  }
  return errors;
};

const radioButton = field => {
  const { type, label } = field;
  return (
    <div className={styles['single-radio']}>
      <label>
        <input {...field.input} type={type} disabled={field.disabled} />{' '}
        <span>{label}</span>
      </label>
    </div>
  );
};

const itemFieldArray = ({
  fields,
  items,
  selectedOutlets,
  variants,
  formValuesReward,
  dispatch,
  detailPromo,
}) => {
  const doms = [];
  fields.map((item, index) => {
    doms.push(
      <div key={index}>
        {index !== 0 && (
          <li>
            <div className={`col-sm-12 ${styles['relations-wrapper']}`}>
              <div className={`col-sm-2 ${styles['btn-relationship']}`}>
                <Field
                  component={ItemRelationField}
                  name="relation"
                  dispatch={dispatch}
                  formValues={formValuesReward}
                  formName="reward"
                  fieldName="relation"
                  disabled={detailPromo !== null}
                />
              </div>
              <div className={`col-sm-10 ${styles.separator}`}>
                <hr />
              </div>
            </div>
          </li>
        )}
        <li>
          <div className={`col-sm-12 ${styles['form-group-wrapper']}`}>
            <div className={`form-group col-sm-3 ${styles['field-qty']}`}>
              <Field
                name={`${item}.quantity`}
                component={SettingField}
                positiveNumberOnly
                maxFractionDigits={0}
                className="form-control"
                placeholder="Qty"
                onChange={e => {
                  const val = e.target.value;
                  if (isNaN(val) || parseInt(val) < 0 || parseInt(val) > 99) {
                    e.preventDefault();
                  }
                }}
                dis={detailPromo !== null}
              />
            </div>
            <div className={`form-group col-sm-1 ${styles.of}`}>of</div>
            <div className={`form-group col-sm-7 ${styles['field-name']}`}>
              {detailPromo ? (
                <Field name={`${item}.name`} component={ReadOnlyItemVariant} />
              ) : (
                <Field
                  name={`${item}.name`}
                  component={SearchItemOrCategory}
                  options={items}
                  placeholder="Select Item"
                  onChangeItem={e => {
                    if (formValuesReward.rewardType === 'freeItem') {
                      dispatch(
                        onChangeItemRewardBuyXGetY(
                          `${item}.name`,
                          e.value,
                          variants,
                          selectedOutlets
                        )
                      );
                    }
                  }}
                  disabled={detailPromo}
                />
              )}
            </div>
            <div className={`col-sm-1 ${styles.remove}`}>
              <i
                className={`fa fa-times-circle fa-lg ${styles['x-button']}`}
                onClick={() => {
                  if (!detailPromo) {
                    fields.remove(index);
                  }
                }}
              />
            </div>
          </div>
        </li>
        <li>
          <div className={`col-sm-12 ${styles['form-group-wrapper']}`}>
            <div className={`form-group col-sm-3 ${styles['field-qty']}`} />
            <div className={`form-group col-sm-1 ${styles.of}`} />
            <div className={`form-group col-sm-7 ${styles['field-name']}`}>
              {detailPromo ? (
                <Field
                  name={`${item}.variantName`}
                  component={ReadOnlyItemVariant}
                />
              ) : (
                <Field
                  name={`${item}.variantName`}
                  component={OptionVariantField}
                  formIndexKey={index}
                  formValues={formValuesReward}
                  variants={variants}
                />
              )}
            </div>
          </div>
        </li>
      </div>
    );
  });

  return (
    <ul className={styles['raw-group']}>
      {doms}
      {!detailPromo && (
        <li>
          <button
            type="submit"
            className="btn btn-primary btn-block"
            onClick={e => {
              e.preventDefault();
              fields.push({
                variantName: 'no variant',
              });
            }}
          >
            Add Item
          </button>
        </li>
      )}
    </ul>
  );
};

class BuyXGetY extends Component {
  render() {
    const {
      handleSubmit,
      isValidReward,
      items,
      variants,
      selectedOutlets,
      formValuesReward,
      detailPromo,
    } = this.props;

    // This code will block next button if there are no item selected
    let blockButton = false;
    if (formValuesReward && formValuesReward.items) {
      formValuesReward.items.forEach(item => {
        if (!item.quantity || !item.variantName) {
          blockButton = true;
        }
      });
    }
    const notValidItem = formValuesReward
      ? !formValuesReward.items ||
        formValuesReward.items.length === 0 ||
        blockButton
      : false;

    // This code will block next button based on purchase type
    const isDisabledButton =
      formValuesReward && formValuesReward.rewardType === 'freeItem'
        ? notValidItem
        : !isValidReward;

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <span className={styles['reward-title']}>Customer will get</span>
          <div className={styles['radio-wrapper']}>
            <Field
              name="rewardType"
              type="radio"
              value="freeItem"
              component={radioButton}
              label="Free Item"
              disabled={detailPromo !== null}
              onChange={() => {
                this.props.dispatch(change('reward', 'relation', 'AND'));
                this.props.dispatch(change('reward', 'items', []));
              }}
            />
            <Field
              name="rewardType"
              type="radio"
              value="discount"
              component={radioButton}
              label="Discount"
              disabled={detailPromo !== null}
              onChange={() => {
                this.props.dispatch(destroy('reward'));
              }}
            />
            {formValuesReward && formValuesReward.rewardType === 'freeItem' ? (
              <FieldArray
                name="items"
                component={itemFieldArray}
                items={items}
                variants={variants}
                selectedOutlets={selectedOutlets}
                formValuesReward={formValuesReward}
                dispatch={this.props.dispatch}
                detailPromo={detailPromo}
              />
            ) : (
              <div className="row">
                <div className={`col-sm-12 ${styles['form-discount-wrapper']}`}>
                  <div
                    className={`form-group col-sm-6 ${styles['field-amount']}`}
                  >
                    <Field
                      name={`discountAmount`}
                      component={SettingField}
                      type="text"
                      className="form-control"
                      placeholder="Amounts"
                      positiveNumberOnly
                      maxFractionDigits={
                        formValuesReward &&
                        formValuesReward.discountType === true
                          ? 3
                          : 0
                      }
                      onChange={e => {
                        const val = e.target.value;
                        if (formValuesReward.discountType === true) {
                          if (isNaN(val) || parseInt(val) > 100) {
                            e.preventDefault();
                          }
                        }
                      }}
                      dis={detailPromo !== null}
                    />
                  </div>
                  <div
                    className={`form-group col-sm-3 ${styles['field-switch']}`}
                  >
                    <Field
                      name={`discountType`}
                      component={SwitchField}
                      type="checkbox"
                      onText="%"
                      offText="Rp"
                      discount
                      onChange={this._onChangeSwitch}
                      disabled={detailPromo !== null}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={styles['reward-detail-form']} />
          <button
            type="submit"
            className={`btn btn-default ${styles['btn-next']}`}
            disabled={isDisabledButton}
          >
            Next
          </button>
          <button
            type="button"
            className={`btn btn-default ${styles['btn-previous']}`}
            onClick={this._handlePrevious}
          >
            Previous
          </button>
        </form>
      </div>
    );
  }

  _onChangeSwitch = () => {
    this.props.dispatch(onChangeSwitchField());
  };

  _handlePrevious = () => {
    this.props.dispatch(setAccordionActiveKey('2'));
  };
}

const mapForm = {
  form: 'reward',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

function mapStateToProps(state) {
  const { items, variants, detailPromo } = state.businessLibrary.promo;
  return {
    isValidReward: isValid('reward')(state),
    formValuesReward: getFormValues('reward')(state),
    items,
    variants,
    detailPromo,
  };
}

export default connect(mapStateToProps)(reduxForm(mapForm)(BuyXGetY));
